<template>
  <v-card class="border shadow1">
    <div class="tituloBox p-l-15">
      <div class="bg-red barraTitulo"></div>
      <h1 class="text-default font-size-18">
        <strong>Acesso</strong> ao Cadastro
      </h1>
    </div>
    <v-form v-model="valid" ref="formLogin">
      <v-layout row wrap>
        <v-flex xs12 md4>
          <v-switch
            v-model="login.flagEstrangeiro"
            label="Sou Estrangeiro"
            color="info"
            value="0"
            hide-details
          ></v-switch>
        </v-flex>

        <v-flex xs12 md8>
          <v-text-field
            v-model="login.Num_cgc_fornecedor"
            :label="  (login.flagEstrangeiro ? $t('label.numeroDocumento')   : $t('label.cpfOuCnpj'))+ ' *'"
            v-mask="maskCpfCnpj"
            required
            :rules="login.flagEstrangeiro ? [] : validacao.cpfCnpj"
            validate-on-blur
            v-on:keyup.13="logar"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-text-field
            v-model.trim="login.Senha"
            label="Senha *"
            type="password"
            :rules="validacao.campoObrigatorio"
            v-on:keyup.13="logar"
            required
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 p-b-15 p-t-10>
          <v-btn large color="success" @click="logar()">Acessar Cadastro</v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-card>
</template>
<script>
import loginService from "../../../services/loginService";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import VueJwtDecode from "vue-jwt-decode";

export default {
  name: "loginForm",
  mixins: [util],
  data() {//Declaracao de variaveis
    return {
      valid: true,
      login: {}
    };
  },
  computed: {//Campos computados
    maskCpfCnpj() {
      let str = "";
      let i = 0;
      for ( ; i < 14; i++) {
        str += "X";
      }
      return this.login.flagEstrangeiro
        ? [str]
        : ["###.###.###-##", "##.###.###/####-##"];
    }
  },
  methods: {//Declaracao de todos os metodos
    logar() {
      if (this.$refs.formLogin.validate()) {
        this.$mostrarPreload(); /*Exibir o PreLoad*/
        var cgc_fornecedor = "";

        if(this.login.flagEstrangeiro){
          cgc_fornecedor = this.login.Num_cgc_fornecedor;
        }else{
          cgc_fornecedor = this.login.Num_cgc_fornecedor.replace(/[^\d]+/g,"");
        }
        let model = {
          Num_cgc_fornecedor: cgc_fornecedor,
          Senha: this.login.Senha
        };

        loginService
          .logar(model)
          .then(response => { /*resposta do servico*/
          
            let tokenObj = VueJwtDecode.decode(response.data.token);
            let fornecedor = JSON.parse(tokenObj.fornecedor);
            this.$store.commit("setToken", response.data.token);
            this.$store.commit("setTokenRefresh", response.data.tokenRefresh);

            switch (fornecedor.SituacaoSolicitacao) {
              case 1:
                if(fornecedor.situacaoSIMPAS !== ""){
                  this.$router.push("fornecedor-painel");
                }else{
                  this.$router.push("cadastro");
                }
                break;
              default:
                this.$router.push("fornecedor-painel");
                break;
            }
          })
          .catch((error) => {
            localStorage.removeItem("id_tipo_documento_sei");
            this.$removePreload(); /*Ocultar o PreLoad*/
          });
      }
    }
  }
};
</script>
